import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import useBranch from 'client/hooks/useBranch';

import { hasRoleAdmin } from 'common/utility/userRoles';

import useDispatch from 'client/hooks/useDispatch';
import getPartnersInGroupAction from 'client/actions/UtilityPartnerGroup/getPartnersInGroup';

import SrLink from 'client/components/SrLink/SrLink';
import './SrPartnerGroupAdminLinks.less';

export const getVisiblePartners = ({ groupPartners, utilityUser }) => {
  if (hasRoleAdmin(utilityUser.roles)) {
    return groupPartners;
  }

  return groupPartners.filter((partner) => {
    return utilityUser.partners.find((userPartner) => userPartner.id === partner.id);
  });
};

const SrPartnerGroupAdminLinks = ({ utilityUser, utilityPartnerGroupId }) => {
  const dispatch = useDispatch();
  const { groupPartners } = useBranch({
    groupPartners: ['utilityPartners', 'byPartnerGroupId', utilityPartnerGroupId],
  });

  useEffect(() => {
    dispatch(getPartnersInGroupAction, { utilityPartnerGroupId });
  }, [dispatch, utilityPartnerGroupId]);

  if (!groupPartners) {
    return null;
  }

  const partners = getVisiblePartners({ groupPartners, utilityUser });

  return (
    <div styleName="partnerGroupAdminLinks">
      {partners.map((partner) => (
        <SrLink key={partner.id} to={`/utility-profit/${partner.slug}`}>
          <span styleName="option info">
            <span>{partner.name}</span>
          </span>
        </SrLink>
      ))}
    </div>
  );
};

SrPartnerGroupAdminLinks.propTypes = {
  utilityPartnerGroupId: PropTypes.number.isRequired,
};

SrPartnerGroupAdminLinks.displayName = 'SrPartnerGroupAdminLinks';

export default SrPartnerGroupAdminLinks;
